import { alpha } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';
export function tabs(theme) {
    const H = 48;
    const R = 12;
    const PX = 20;
    return {
        MuiTabs: {
            styleOverrides: {
                root: { minHeight: H },
                flexContainer: {
                    gap: 0,
                    borderBottom: `2px solid ${alpha(theme.palette.grey[500], 0.08)}`
                },
                indicator: {},
                scrollButtons: {
                    width: 48,
                    borderRadius: '50%',
                    // Tab labels are white, so the chevrons must be too; otherwise they inherit
                    // the dark text.primary and vanish on the black company background
                    color: theme.palette.common.white
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: H,
                    height: H,
                    minWidth: 0,
                    padding: `0 ${PX}px`,
                    textTransform: 'none',
                    lineHeight: 1,
                    borderRadius: R,
                    fontWeight: theme.typography.fontWeightSemiBold,
                    border: '1px solid transparent',
                    opacity: 1,
                    // '&:not(:last-of-type)': {
                    //   marginRight: theme.spacing(1.5)
                    // },
                    [`&.${tabClasses.selected}`]: {
                        color: theme.palette.common.white,
                        fontWeight: 500,
                        backgroundColor: 'transparent'
                    },
                    [`&:not(.${tabClasses.selected})`]: {
                        color: alpha(theme.palette.common.white, 0.9),
                        fontWeight: 500,
                        '&:hover': {},
                        '&:active': {}
                    },
                    // disabled
                    [`&.Mui-disabled`]: {
                        color: theme.palette.text.disabled,
                        borderColor: 'transparent'
                    }
                }
            }
        }
    };
}
